import { useInjection } from "@linkfluence/core/di";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { InsightPage } from "@radarly/models/insight-pages/model";
import {
  InsightPageRepo,
  InsightPageRepositoryUID,
} from "../repositories/InsightPageRepo";

export function useDeleteInsightPage() {
  const repository = useInjection<InsightPageRepo>(InsightPageRepositoryUID);
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading } = useMutation(
    ({ project, id }: { project: number; id: InsightPage["id"] }) => {
      return repository.deleteInsightPage(project, id);
    },
    {
      onSuccess: (res, { project, id }) => {
        queryClient.invalidateQueries(["/insight-pages/search"]);
        queryClient.invalidateQueries([
          "/insight-pages/list",
          {
            project,
          },
        ]);
        queryClient.invalidateQueries(["/insight-page/get", { project, id }]);
      },
    }
  );
  const deleteInsightPage = async (data: {
    project: number;
    id: InsightPage["id"];
  }) => {
    await mutateAsync(data);
  };
  return {
    deleteInsightPage,
    loading: isLoading,
  };
}
